// analytics.ts
import posthog from 'posthog-js';

const environment = process.env.REACT_APP_ENVIRONMENT || 'unknown';

// Initialize PostHog with environment variables
posthog.init(process.env.REACT_APP_POSTHOG_API_KEY,
  {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    persistence: 'cookie',
    // @ts-ignore
    cookie_domain: 'playmix.ai',
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
      recordCrossOriginIframes: true,
    }
  }
);

// Register the environment as a property to be included with all subsequent events
posthog.register({
  environment: environment,
});

// Export the initialized PostHog instance for use throughout the app
export default posthog;

// Helper functions for common analytics operations
export const trackPageView = (pathname: string, title: string) => {
  posthog.capture('$pageview', {
    path: pathname,
    title: title
  });
};

export const trackPageLeave = (pathname: string, title: string) => {
  posthog.capture('$pageleave', {
    path: pathname,
    title: title
  });
};

export const identifyUser = (userId: string, traits: Record<string, any> = {}) => {
  posthog.identify(userId, traits);
};

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  posthog.capture(eventName, properties);
};